import { useEffect, useRef, useState } from 'react';

export function useReveal(options = {}) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setVisible(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          if (options.once !== false) observer.disconnect();
        }
      },
      { threshold: options.threshold ?? 0.12, rootMargin: options.rootMargin ?? '0px' }
    );

    observer.observe(el);

    // Si ya está en viewport al montar (p. ej. tras resize), mostrar sin esperar scroll
    const rect = el.getBoundingClientRect();
    if (rect.top < window.innerHeight * 0.92 && rect.bottom > 0) {
      setVisible(true);
      if (options.once !== false) observer.disconnect();
    }

    return () => observer.disconnect();
  }, [options.once, options.threshold, options.rootMargin]);

  return {
    ref,
    isVisible: visible,
    className: visible ? 'reveal is-visible' : 'reveal',
  };
}

export default useReveal;
